import * as types from "../types/break.types";
import { getBreakList, getBreakMark } from "../../services/break.service";
import { validationErrors } from "../../utils/Helpers";
import { swalNotification } from "../../components/alret/notificztion";

export const breakListAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await getBreakList(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_TASK_PAGINATION,
            payload: res.data.pagination,
          });
          dispatch({
            type: types.SET_TASK_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const breakListFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_TASK_FILTER,
      payload: data,
    });
  };
};



export const breakMarkAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await getBreakMark(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data
      ).then((res) => {
        if (res.data.code === 200) {
          swalNotification (
            "",
            res.data.message
          );
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};


